const nodeEnv = process.env;

export const AppConfig = {
  api_url: nodeEnv.REACT_APP_API_URL ?? 'https://api.squadcast.com',
  webforms_url: nodeEnv.REACT_APP_WEBFORM_URL ?? 'webforms.squadcast.com',
  recaptcha_sitekey_webforms:
    nodeEnv.REACT_APP_CAPTCHA_SITEKEY_WEBFORMS ?? '6LcfnnMpAAAAABp4arXnwTKE7BVWY-GnAGY2B-4M',
};
